import React from "react";
import { Routes, Route } from 'react-router-dom';
import HomePage from '../Pages/Home/Home';
import ServicesDetails from '../Pages/servicesDetails/ServicesDetails';

function Router() {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/service/:slug" element={<ServicesDetails />} />
        </Routes>
    );
}

export default Router;